import { connect } from 'react-redux'
import { getStats, getStatsDetail, setSelectYear, setSelectMonth, statsLoginTransaction, statsLoginTransaction2 } from '../../../redux/statistic/action'

import Login from './Login'

const mapStateToProps = (state) => ({
  collection: state.statistic.collection || [],
  detail: state.statistic.detail || [],
  year: state.statistic.year || {},
  month: state.statistic.month || {}
})

const mapDispatchToProps = {
  loadStats: (type, year) => getStats(type, year),
  loadStatsDetail: (type, year, month) =>
    getStatsDetail(type, year, month),
  setYear: (year) => setSelectYear(year),
  setMonth: (month) => setSelectMonth(month),
  getStatsLoginTransaction: (year, month) => statsLoginTransaction(year,month),
  getStatsLoginTransaction2: (year, month) => statsLoginTransaction2(year,month)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)
